// FP3-034H — Single source of truth for service-duration option arrays.
//
// Before this module, three surfaces had their own hardcoded copies:
//
//   DocumentQuickSessionDialog.jsx → [10, 15, 30]
//   ScheduleBuilder.jsx             → [5, 10, 15, 20, 30]
//   LiveDataCollection.js           → [10, 15, 30]
//   ScheduleWizard.jsx              → [5, 10, 15, 20, 30, 45, 60] (dead)
//
// Real therapy slots routinely run 20 / 25 / 35 / 40 / 45 minutes
// (district push-in cycles, RTI tiers, pull-out micro-sessions, …),
// so providers had to either fudge a documented session minute count
// or split a real 25-minute slot into multiple fake sessions. This
// module centralizes the options and lets each surface choose the
// slice that matches its UX semantics:
//
//   DOCUMENT_SESSION_MINUTE_OPTIONS — Document Session + Live tracker
//     quick-duration picker. No 5 (a logged session shorter than 10
//     minutes isn't meaningful service); top out at 45 (longer slots
//     are scheduled, not quick-logged).
//
//   SERVICE_BLOCK_MINUTE_OPTIONS — Schedule Builder "Add block"
//     palette. Keeps 5 so providers can drop a quick consultation
//     block; tops out at 45 because longer blocks are rare and the
//     wizard / manual time-edit handles them.
//
//   WIZARD_DURATION_OPTIONS — Schedule Wizard. Keeps 60 for IEP-style
//     long blocks the wizard may suggest based on student needs.
//
// Backend `delivered_minutes` and `duration_min` are unconstrained
// integers — no API gating, no rounding. New values flow through
// existing fidelity, reconciliation, and reporting code with no
// schema changes.
export const DOCUMENT_SESSION_MINUTE_OPTIONS = Object.freeze([
  10, 15, 20, 25, 30, 35, 40, 45,
]);

export const SERVICE_BLOCK_MINUTE_OPTIONS = Object.freeze([
  5, 10, 15, 20, 25, 30, 35, 40, 45,
]);

export const WIZARD_DURATION_OPTIONS = Object.freeze([
  5, 10, 15, 20, 25, 30, 35, 40, 45, 60,
]);
